import React, { useContext, useEffect } from "react";
import { deleteCookie, DeleteTemplateDocId } from "../../Util/helper";
import ColorSelector from "../ColorSelector/ColorSelector";
import SliderComponent from "../Slider/SliderComponent";
import TemplateDataContext from "../../Contexts/TemplateData.context";
import FormDataContext from "../../Contexts/FormData.context";
import { colors, formActionEnum, templateActionEnum } from "../../Config/Constants";

export default function ChooseTemplate() {
  const { dispatch: formDispatch } = useContext(FormDataContext);
  const { state: templateState, dispatch } = useContext(TemplateDataContext);
  const { templatePath, selectedState, templates } = templateState;

  useEffect(() => {
    const footer = document.querySelector(".temp-footer #minimal-footer");
    const slickSlider = document.querySelector(".slick-slider");

    if (footer && window.innerWidth < 768) {
      (footer as HTMLElement).style.marginBottom = slickSlider ? "0px" : "75px !important";
    }
    if (footer) {
      (footer as HTMLElement).style.position = slickSlider ? "relative" : "";
    }
    formDispatch({ type: formActionEnum.RESET_FORM_DATA });
    formDispatch({ type: formActionEnum.RESET_STEP_DATA });
    formDispatch({ type: formActionEnum.SET_COLOR, payload: colors[9] });
    formDispatch({ type: formActionEnum.SET_DOC_ID, payload: "" });
    formDispatch({ type: formActionEnum.SET_PARAGRAPH, payload: {} });
    formDispatch({ type: formActionEnum.RESET_BLANK_FORM_DATA });
    //dispatch({ type: templateActionEnum.SET_STEP_FLAG, payload: false });
    //dispatch({ type: templateActionEnum.SET_NAVBAR_STATE, payload: false });
    DeleteTemplateDocId(templatePath, true);
    //deleteCookie("docid");
  }, []);
  return (
    <section className="">
      <div className="container">
        {/* <div className="card-header headerheight">
            </div> */}
        <div className="title-wrap text-center">
          <h1 className="page-title mb-3">
            Choose the <b>best templates</b> for your needs
          </h1>
          <p className="sub-title mb-4">
            {selectedState !== "" ? "Pick from ten colors." : "Pick from three templates ten colors."}
          </p>
        </div>

        <div className="color-section">
          <ColorSelector />
        </div>

        <SliderComponent />
      </div>
    </section>
  );
}
